import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, actionDelColumnCusDis } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P207List({ dataTable, deleteDialog, setheadlerInpusText, addRowtable, onChangeDrop, dropdownOrderTypeList, dis }) {

    const actionBodyDel = (rowData) => deleteDialog({ open: true, data: rowData });
    const [pageConf, setPageConf] = useState({ first: 0, rows: 5 });

    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive "
                icon="pi pi-plus"
                label="เพิ่มรายการ"
                onClick={() => {
                    addRowtable(dataTable);
                }}
                disabled={dis}
            />
        </div>
    );

    const DropdownAndInputCulumn = (rowData, checkColumn, listboxValue, setListboxValue, mandatory, titleShow, dropName, onChangeInputext, maxLength, inputnme, dis) => {
        let data = { ...rowData };
        let datavalue = (data["checkColumn"] = checkColumn);
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-6">
                        <Dropdown
                            id={`${dropName}_${data.index}`}
                            value={listboxValue.length > 0 ? listboxValue[data.index][dropName] : ""}
                            className={mandatory}
                            onChange={(e) => {
                                setListboxValue(e.value, rowData, dropName);
                            }}
                            options={datavalue}
                            optionLabel="name"
                            optionValue="code"
                            style={{ width: "100%" }}
                            disabled={dis}
                        />
                    </div>
                    {listboxValue[data.index][dropName] === "999" && (
                        <div className="p-field p-col-12 p-md-6">
                            <InputText id="otherDesc" type="text" maxLength={maxLength} value={rowData && rowData[inputnme] ? rowData[inputnme] : ""} onChange={(e) => onChangeInputext(e.target.value, rowData, inputnme)} disabled={dis} />
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    header={header}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="orderSeq" header="ลำดับ" body={(e) => normalColumn(e, "orderSeq", "ลำดับ")} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column
                        field="orderTopic"
                        header="รายละเอียด"
                        body={(e) => DropdownAndInputCulumn(e, dropdownOrderTypeList, dataTable, onChangeDrop, "", "ขนาด", "orderTopic", setheadlerInpusText, "500", "otherDesc", dis)}
                        style={{ textAlign: "center", width: "30%" }}
                        bodyStyle={bodyStyle.TXT_LEFT}
                    />
                    <Column header="ลบรายการ" field="photoPath" body={(e) => actionDelColumnCusDis(e, actionBodyDel, dis)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
                <br/>
            {/* </div> */}
        </div>
    );
}
